/**
 * The one relative-time formatter. Three components each grew their own copy
 * (TimelineTab, NotificationsBell, AdminActivityStream) while a fourth surface
 * (FAWorkspaceOverview) rendered the raw ISO string — which is exactly what
 * happens when a formatter is copy-paste distance away instead of import
 * distance. Import this; do not fork it.
 */
export function formatRelative(iso: string | null | undefined, fallback = ''): string {
  if (!iso) return fallback
  const t = new Date(iso).getTime()
  if (Number.isNaN(t)) return fallback
  const secs = Math.floor((Date.now() - t) / 1000)
  if (secs < 60) return 'just now'
  if (secs < 3600) return `${Math.floor(secs / 60)}m ago`
  if (secs < 86400) return `${Math.floor(secs / 3600)}h ago`
  if (secs < 604800) return `${Math.floor(secs / 86400)}d ago`
  return new Date(iso).toLocaleDateString()
}
